var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 206,
    viewBox: "0 0 360 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 67.6868V151.474C359.921 157.705 357.177 164.506 353.419 170.025C349.344 176.011 343.439 179.412 337.245 179.405L313.02 179.385C309.468 152.893 277.674 152.838 274.137 179.385H234.319C230.773 152.825 199.031 152.92 195.437 179.385L189.639 179.412C164.505 179.385 150.487 154.332 143.002 128.199H166.756C173.237 140.356 175.14 150.551 193.27 150.463C193.27 150.463 276.294 150.463 317.788 150.463C328.65 150.463 337.451 139.154 337.451 125.212V67.6868H359.995H360Z",
    fill: "#F7BB17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.944 179.385C305.91 155.166 276.12 159.741 276.738 184.571C277.272 216.357 315.356 210.398 309.944 179.385ZM293.584 194.61C283.462 194.786 283.409 174.376 293.584 174.505C303.754 174.355 303.727 194.793 293.584 194.61Z",
    fill: "#F7BB17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.243 179.385C227.226 155.194 197.446 159.687 198.038 184.571C198.572 216.357 236.656 210.398 231.243 179.385ZM214.884 194.61C204.761 194.786 204.708 174.376 214.884 174.505C225.059 174.376 225.006 194.793 214.884 194.61Z",
    fill: "#F7BB17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.763 0C103.443 8.07055 98.2472 20.8789 94.9065 28.9495H0V0H106.763Z",
    fill: "#AD2159"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.567 60.5936C305.567 89.9504 287.04 113.741 264.2 113.741C261.61 113.599 139.159 111.06 136.596 110.985C130.802 98.1024 107.688 46.6993 101.477 32.8727C102.106 31.3659 112.899 4.9618 113.883 2.55896C122.974 22.8406 141.548 64.0893 150.809 84.7103H260.056C271.843 86.5973 283.509 76.728 283.403 60.5936C282.473 26.1937 241.688 38.4726 225.318 36.4227V71.0738H202.795V7.47324H263.006L262.984 7.52754C286.226 6.5026 305.604 30.7618 305.562 60.5936H305.567Z",
    fill: "#AD2159"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 59.1885L96.2967 54.4575V63.9128L24.1667 59.1885Z",
    fill: "#F7BB17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1135 126.706L126.198 123.482V132.937L78.1135 126.706Z",
    fill: "#F7BB17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0586 93.6971L108.163 88.9729V98.4281L48.0586 93.6971Z",
    fill: "#F7BB17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDns);
export default __webpack_public_path__ + "static/media/dns.d66cc555c49489b4a965df73d7af39ab.svg";
export { ForwardRef as ReactComponent };